import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';

const classes = {
	itemBtn: 'm-teaser-large__caption-button'
};

//const data = require('../_data/teaser-large.json');
@createModule('TeaserLarge')
/*
 * teaser-large module implementation.
 */
export class TeaserLarge extends TerrificSpec {
	$ctx: JQuery;
	title: any;
	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		setTimeout(() => {
			var title = $('.m-teaser-large__caption-title');
			var description = $('.m-teaser-large__caption');
			if (title.hasClass('SL') || description.hasClass('SL')) {
				$('.m-teaser-large__caption-title').removeClass('large').addClass('small');
				$('.m-teaser-large__caption').removeClass('small').addClass('large');
			} else if (title.hasClass('LS') || description.hasClass('LS')) {
				$('.m-teaser-large__caption-title').removeClass('small').addClass('large');
				$('.m-teaser-large__caption').removeClass('large').addClass('small');
			} else if (title.hasClass('LL') || description.hasClass('LL')) {
				$('.m-teaser-large__caption-title').removeClass('small').addClass('large');
				$('.m-teaser-large__caption').removeClass('small').addClass('large');
			} else if (title.hasClass('SS') || description.hasClass('SS')) {
				$('.m-teaser-large__caption-title').removeClass('large').addClass('small');
				$('.m-teaser-large__caption').removeClass('large').addClass('small');
			}
		}, 0);

		this.RegisteredUpdate();

		resolve();
	}

	RegisteredUpdate() {
		if (Track.isKnownMarketoLead()) {
			this.$ctx.removeClass('m-teaser-large--locked');
		}
		if (Track.isKnownCdcLead()) {
			this.$ctx.removeClass('m-teaser-large--locked');
		}
	}

	stop() { }

}
